import { ReactNode } from "react";

import styled from "styled-components";

const Container = styled.div`
  position: relative;
  display: flex;
  flex: 1;
  overflow: hidden;

  > :not(.drawer) {
    flex: 1;
  }
`;

type Props = {
  children: ReactNode;
};

export const Wrapper = ({ children }: Props): JSX.Element => (
  <Container>{children}</Container>
);
